import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Box, Button, Grid, HStack, VStack, useToast } from "@chakra-ui/react";
import * as Yup from "yup";
import CustomField from "../../Common/Form/CustomField";
import { useHistory } from "react-router-dom";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import { Prompt } from "react-router";
import ConfirmationSwal from "../../../Utils/confirmationSwal";

const SupplierForm = ({ supplier, id }) => {
  const { post, put } = useFetch();
  const history = useHistory();
  const toast = useToast();
  const [isSubmitting, setIsSubmiting] = useState(false);
  const [isEdited, setIsEdited] = useState(false);

  const SupplierSchema = Yup.object().shape({
    businessName: Yup.string().nullable().required("Ingrese una razón social"),
    address: Yup.string().nullable().required("Ingrese una dirección"),
    cuit: Yup.string().nullable().required("Ingrese un CUIT"),
    phone: Yup.string().nullable().required("Ingrese un teléfono"),
  });

  const submitHandler = async (form, isRedirecting) => {
    await form.submitForm();
    if (Object.keys(await form.validateForm()).length !== 0) return false;
    setIsSubmiting(true);
    const value = form.values;
    let data = {
      businessName: value.businessName,
      address: value.address,
      cuit: value.cuit,
      phone: value.phone,
    };
    setIsEdited(false);
    if (id == "new") {
      await post("/suppliers", data)
        .then((res) => {
          toast({
            title: "Proveedor guardado con éxito.",
            description: "Se ha guardado la información del proveedor.",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          if (isRedirecting) {
            history.push("/proveedores");
          } else {
            history.replace("/proveedores");
            history.push(`/proveedores/${res.id}`);
          }
        })
        .catch((e) => {
          toast({
            title: "Se ha producido un error.",
            description:
              e?.message || "Contacte con el administrador del sistema.",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        })
        .finally(() => {
          setIsSubmiting(false);
        });
    } else {
      await put(`/suppliers/${id}`, data)
        .then(async (res) => {
          toast({
            title: "Proveedor guardado con éxito.",
            description: "Se ha modificado la información del proveedor.",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          if (isRedirecting) {
            history.push("/proveedores");
          } else {
            history.replace("/proveedores");
          }
        })
        .catch((e) => {
          toast({
            title: "Se ha producido un error.",
            description:
              e?.message || "Contacte con el administrador del sistema.",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        })
        .finally(() => {
          setIsSubmiting(false);
        });
    }
  };

  const handleIsEdited = () => {
    setIsEdited(true);
  };

  const handleBlockedNavigation = (nextLocation) => {
    if (isEdited) {
      setIsEdited(false);
      ConfirmationSwal.fire({
        title: "Parece que hay cambios no guardados",
        text: "Desea salir de la página?",
        icon: "question",
        confirmButtonText: "Sí, salir",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          history.push(nextLocation.pathname);
        }
      });
      return false;
    }
    return true;
  };

  return (
    <>
      <Box pb="1rem">
        <Formik
          initialValues={supplier}
          onSubmit={() => {}}
          validationSchema={SupplierSchema}
        >
          {(props) => (
            <Form>
              <ContentCard w={["auto"]}>
                <Grid
                  templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
                  gap={6}
                >
                  <Box>
                    <VStack align="left" w="100%">
                      <CustomField
                        name="businessName"
                        title="Razón social: "
                        placeholder="Ingrese una razón social"
                        type="text"
                        props={props}
                        customStyle={{ textTransform: "uppercase" }}
                        setIsEdited={handleIsEdited}
                      ></CustomField>
                      <CustomField
                        name="address"
                        title="Dirección: "
                        placeholder="Ingrese una dirección"
                        type="text"
                        props={props}
                        customStyle={{ textTransform: "uppercase" }}
                        setIsEdited={handleIsEdited}
                      ></CustomField>
                    </VStack>
                  </Box>

                  <VStack>
                    <CustomField
                      name="cuit"
                      title="CUIT: "
                      placeholder="Ingrese un CUIT"
                      type="text"
                      props={props}
                      customStyle={{ textTransform: "uppercase" }}
                      setIsEdited={handleIsEdited}
                    ></CustomField>
                    <CustomField
                      name="phone"
                      title="Teléfono: "
                      placeholder="Ingrese un teléfono"
                      type="text"
                      props={props}
                      customStyle={{ textTransform: "uppercase" }}
                      setIsEdited={handleIsEdited}
                    ></CustomField>
                  </VStack>
                </Grid>
                <HStack
                  justify={["center", "flex-end"]}
                  mt="2rem"
                  wrap={"wrap"}
                  gap="0.5rem"
                >
                  <Button variant="ghost" onClick={() => history.goBack()}>
                    Cancelar
                  </Button>
                  <Button
                    colorScheme="blue"
                    isLoading={isSubmitting}
                    onClick={() => submitHandler(props, true)}
                  >
                    Guardar
                  </Button>
                  <Button
                    colorScheme="blue"
                    isLoading={isSubmitting}
                    onClick={() => submitHandler(props, false)}
                  >
                    Guardar y seguir editando
                  </Button>
                </HStack>
              </ContentCard>
            </Form>
          )}
        </Formik>
      </Box>
      <Prompt when={isEdited} message={(e) => handleBlockedNavigation(e)} />
    </>
  );
};

export default SupplierForm;
